import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';


// Dynamic Table Component for Import Errors
const ImportErrorTable = ({ show, onHide, data, title = "Import Errors", columnError = '' }) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
        return null;
    }

    // Get all unique keys from the data array to create table headers
    const getTableHeaders = (dataArray) => {
        const allKeys = new Set();
        dataArray.forEach(item => {
            if (typeof item === 'object' && item !== null) {
                Object.keys(item).forEach(key => allKeys.add(key));
            }
        });
        return Array.from(allKeys);
    };

    // Format cell value for display
    const formatCellValue = (value) => {
        if (value === null || value === undefined) return '';
        if (typeof value === 'object') return JSON.stringify(value);
        return String(value);
    };

    // Convert Vietnamese keys to readable labels
    const formatHeaderLabel = (key) => {
        const keyMap = {
            'row': 'Dòng',
            'column': 'Cột',
            'error': 'Lỗi',
            'value': 'Giá trị',
            'message': 'Thông báo',
            'field': 'Trường',
            'line': 'Dòng',
            'description': 'Mô tả'
        };
        return keyMap[key] || key.charAt(0).toUpperCase() + key.slice(1);
    };

    const headers = getTableHeaders(data);

    return (
        <Modal show={show} onHide={onHide} size="xl" centered>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                <div className="alert alert-warning mb-3">
                    <i className="fas fa-exclamation-triangle mr-2"></i>
                    Có {data.length} lỗi được phát hiện trong quá trình import
                </div>

                <div className="table-responsive">
                    <table className="table table-striped table-bordered table-hover">
                        <thead className="thead-dark">
                        <tr>
                            <th className="text-center" style={{ width: '50px' }}>#</th>
                            {headers.map((header, index) => (
                                <th key={index} className="text-center"  style={{ color: columnError === header ?'red':'' }} >
                                    {formatHeaderLabel(header)}
                                </th>
                            ))}
                        </tr>
                        </thead>
                        <tbody>
                        {data.map((item, rowIndex) => (
                            <tr key={rowIndex}>
                                <td className="text-center font-weight-bold">
                                    {rowIndex + 1}
                                </td>
                                {headers.map((header, colIndex) => (
                                    <td  key={colIndex} className="text-center">
                                        {formatCellValue(item[header])}
                                    </td>
                                ))}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </div>

                <div className="mt-3 p-3 bg-light rounded">
                    <small className="text-muted">
                        <strong>Hướng dẫn:</strong> Vui lòng kiểm tra và sửa các lỗi trong file Excel theo thông tin trên,
                        sau đó thực hiện import lại.
                    </small>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Đóng
                </Button>
                <Button variant="primary" onClick={() => {
                    // Export error data to Excel or CSV
                    const csvContent = [
                        headers.join(','),
                        ...data.map(row => headers.map(header => `"${formatCellValue(row[header])}"`).join(','))
                    ].join('\n');

                    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
                    const link = document.createElement('a');
                    const url = URL.createObjectURL(blob);
                    link.setAttribute('href', url);
                    link.setAttribute('download', 'import_errors.csv');
                    link.style.visibility = 'hidden';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }}>
                    <i className="fas fa-download mr-2"></i>
                    Tải xuống lỗi
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
export default ImportErrorTable;